import { createElement, forwardRef, HTMLAttributes, memo, ReactNode } from "react";
import { createPortal } from "react-dom";
import { useMergedRef } from "../../utils";

export const getPortalComponents = () => {
  const virtualDomNode = document.createElement("div");

  const processRef = (node: HTMLDivElement | null) => {
    if (node && !node.contains(virtualDomNode)) {
      node.appendChild(virtualDomNode);
    }
  };

  const PortalContentProvider = (props: { children?: ReactNode }) =>
    createPortal(props.children, virtualDomNode);

  const Container = memo(
    forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
      (props, ref) =>
        createElement("div", {
          ...props,
          ref: useMergedRef(processRef, ref),
        })
    )
  );

  return {
    Container,
    PortalContentProvider,
  };
};